<div *ngIf="!show && (loaderService.isLoading$ | async)" class="spinner-overlay">
  <div [classList]="['loader', size].join(' ')"></div>
</div>
<div *ngIf="show" [classList]="['loader', size].join(' ')"></div>
